import { render, staticRenderFns } from "./create.vue?vue&type=template&id=8fc91d4a"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fc91d4a')) {
      api.createRecord('8fc91d4a', component.options)
    } else {
      api.reload('8fc91d4a', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=8fc91d4a", function () {
      api.rerender('8fc91d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/example/create.vue"
export default component.exports